/**
 *  GeoMonster makes use of CookieMonster's
 *  getCookie() function, but specifically
 *  pre-populates the geo data with empty
 *  strings so we don't run into an error
 *  when cookies are disabled.
 */
import { CookieMonster } from 'root/utils/cookies/cookieMonster';
export class GeoMonster extends CookieMonster {
    constructor() {
        super();

        let geoFields = {
            country: '',
            country_code: '',
            city: '',
            state: '',
            state_code: '',
            continent: '',
            longitude: '',
            latitude: '',
        };
        const c = this.getCookie('geoConfigDebug')
            ? this.getCookie('geoConfigDebug')
            : this.getCookie('geoConfig');
        // The right side of && doesn't evaluate if left
        // side is false. If c is not defined, then left
        // side is false, so the && is false, and the
        // inner block should not run.
        if (typeof c !== 'undefined' && c !== null) {
            for (let field in c) {
                if (c[field] !== null) {
                    geoFields[field] = c[field];
                }
            }
        }

        this.getField = function (field) {
            return geoFields[field];
        };
    }
}
